module.exports = __webpack_public_path__ + "assets/CircleInSquareDetailed.c0bc34abea25a1eeea292d3e3547feb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CircleInSquareDetailed.png
// module id = 488
// module chunks = 0